"use client";

import React, { useState } from "react";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable";
import { formatMoney } from "../utils/utils";

const Remuneraciones = () => {
    const [mes, setMes] = useState("");
    const [resultados, setResultados] = useState([]);

    const buscarCobranza = async () => {
        if (!mes) return;
        // mes viene en formato "YYYY-MM"
        const [anio, mesNum] = mes.split("-");
        try {
            const params = { fecha: mes };
            // Ajusta la ruta si tu endpoint es diferente
            const response = await axiosInstance.get("/acuerdo-mutuo/remuneraciones", { params });
            // Suponemos que tu wrapper deja el array en response.data.data
            setResultados(response.data.data);
        } catch (error) {
            console.error("Error al buscar remuneraciones:", error);
        }
    };

    const columns = [
        { title: "Auxiliar", name: "auxiliar" },
        { title: "Cantidad Turnos", name: "cantidad_turnos" },
        {
            title: "Total Turno",
            name: "total_turno",
            render: row => `$${formatMoney(row.total_turno)}`
        },
        {
            title: "Total Movilización",
            name: "total_movilizacion",
            render: row => `$${formatMoney(row.total_movilizacion)}`
        },
        {
            title: "Total Colación",
            name: "total_colacion",
            render: row => `$${formatMoney(row.total_colacion)}`
        },
        {
            title: "Total Final",
            name: "total_final",
            render: row => `$${formatMoney(row.total_final)}`
        },
    ];

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Honorarios por Mes</h3>
                    <div className="row g-3 align-items-end">
                        <div className="col-md-4">
                            <label className="form-label">Mes</label>
                            <input
                                type="month"
                                className="form-control"
                                value={mes}
                                onChange={e => setMes(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-primary w-100"
                                onClick={buscarCobranza}
                                disabled={!mes}
                            >
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="mt-3">
                        <GdTable
                            columns={columns}
                            data={resultados}
                            stickyHeader={true}
                            height={600}
                            headerHeight={50}
                            showCsvExport={true}
                            initialSort={[0, "asc"]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Remuneraciones;
